(function () {
  'use strict';

  document.querySelectorAll('[data-product-info-pro]').forEach(initProductInfoPro);

  function initProductInfoPro(root) {
    initGallery(root);
    initOptions(root);
    initBundles(root);
    initAddToCart(root);
    initDescriptionToggle(root);
    initBundleTimer(root);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initGallery(root) {
    const mainWrap = root.querySelector('[data-pip-main-image]');
    const mainImg = root.querySelector('[data-pip-main-image-el]');
    const thumbs = root.querySelectorAll('[data-pip-thumb]');
    const track = root.querySelector('[data-pip-thumbs-track]');
    const prevBtn = root.querySelector('[data-pip-thumb-prev]');
    const nextBtn = root.querySelector('[data-pip-thumb-next]');

    if (prevBtn && track) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -160, behavior: 'smooth' });
      });
    }
    if (nextBtn && track) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: 160, behavior: 'smooth' });
      });
    }

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (!fullSrc || fullSrc === mainImg.getAttribute('src')) return;

        mainWrap.classList.add('is-swapping');

        const preload = new Image();
        preload.onload = () => {
          mainImg.setAttribute('src', fullSrc);
          mainWrap.classList.remove('is-swapping');
        };
        preload.src = fullSrc;

        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function initOptions(root) {
    const optionGroups = root.querySelectorAll('[data-pip-option-index]');
    const variantsScript = root.querySelector('[data-pip-variants-json]');
    const variantIdInput = root.querySelector('[data-pip-variant-id]');
    const priceEl = root.querySelector('[data-pip-price]');
    const comparePriceEl = root.querySelector('[data-pip-compare-price]');
    const mainWrap = root.querySelector('[data-pip-main-image]');
    const mainImg = root.querySelector('[data-pip-main-image-el]');

    if (!optionGroups.length) return;

    let variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
    }

    const selections = {};
    optionGroups.forEach((group) => {
      const index = group.getAttribute('data-pip-option-index');
      const active = group.querySelector('.is-active');
      if (active) selections[index] = active.getAttribute('data-value');
    });

   function findMatchingVariant() {
      let match = variants.find((v) => {
        if (!v.options) return false;
        return Object.keys(selections).every((idx) => {
          const i = parseInt(idx, 10);
          const variantValue = (v.options[i] || '').toString().trim().toLowerCase();
          const selectedValue = (selections[idx] || '').toString().trim().toLowerCase();
          return variantValue === selectedValue;
        });
      });

      if (!match) {
        const selectedValues = Object.values(selections).map((v) => (v || '').toString().trim().toLowerCase());
        match = variants.find((v) => {
          const title = (v.title || '').toString().trim().toLowerCase();
          return selectedValues.every((val) => title.indexOf(val) !== -1);
        });
      }

      if (!match) {
        console.warn('[Product Info Pro] No variant match found.', {
          selections: selections,
          availableVariants: variants.map((v) => ({ id: v.id, title: v.title, options: v.options })),
        });
      }

      return match;
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl && typeof variant.price === 'number') {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (variant.featured_image && variant.featured_image.src && mainImg) {
        mainWrap.classList.add('is-swapping');
        const preload = new Image();
        preload.onload = () => {
          mainImg.setAttribute('src', variant.featured_image.src);
          mainWrap.classList.remove('is-swapping');
        };
        preload.src = variant.featured_image.src;
      }

      updateBundlePrices(root, variant);
    }

    optionGroups.forEach((group) => {
      const index = group.getAttribute('data-pip-option-index');
      const buttons = group.querySelectorAll('[data-pip-option-value]');
      const labelEl = group.querySelector('[data-pip-option-selected]');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          buttons.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selections[index] = btn.getAttribute('data-value');
          if (labelEl) labelEl.textContent = selections[index];

          const matched = findMatchingVariant();
          applyVariant(matched);
        });
      });
    });

    root._pipVariants = variants;
    root._pipFindVariantWithOverrides = function (overrides) {
      return variants.find((v) => {
        if (!v.options) return false;
        return Object.keys(selections).every((idx) => {
          const i = parseInt(idx, 10);
          const overrideVal = overrides && overrides[i] !== undefined ? overrides[i] : selections[idx];
          const variantValue = (v.options[i] || '').toString().trim().toLowerCase();
          const selectedValue = (overrideVal || '').toString().trim().toLowerCase();
          return variantValue === selectedValue;
        });
      });
    };
  }

  function updateBundlePrices(root, variant) {
    const tiers = root.querySelectorAll('[data-pip-bundle-tier]');
    tiers.forEach((tier) => {
      if (tier.getAttribute('data-is-multi-product') === 'true') return;

      const qty = parseInt(tier.getAttribute('data-quantity'), 10) || 1;
      const discountPct = parseInt(tier.getAttribute('data-discount-percent'), 10) || 0;
      const manualPriceCents = tier.getAttribute('data-manual-price-cents');

      const originalCents = variant.price * qty;
      let finalCents;
      let discountCents = 0;

      if (manualPriceCents) {
        finalCents = parseInt(manualPriceCents, 10);
        discountCents = originalCents - finalCents;
      } else {
        discountCents = Math.round((originalCents * discountPct) / 100);
        finalCents = originalCents - discountCents;
      }

      const finalEl = tier.querySelector('[data-pip-bundle-final]');
      const originalEl = tier.querySelector('[data-pip-bundle-original]');
      const saveEl = tier.querySelector('[data-pip-bundle-save]');

      if (finalEl) finalEl.textContent = formatMoney(finalCents);
      if (originalEl) {
        originalEl.textContent = formatMoney(originalCents);
        originalEl.style.display = discountCents > 0 ? '' : 'none';
      }
      if (saveEl) {
        saveEl.textContent = 'You Save ' + formatMoney(discountCents);
        saveEl.style.display = discountCents > 0 ? '' : 'none';
      }
    });
  }

  function initBundles(root) {
    const tiers = root.querySelectorAll('[data-pip-bundle-tier]');
    const quantityInput = root.querySelector('[data-pip-quantity-input]');
    const bundlesWrap = root.querySelector('[data-pip-bundles]');

    if (!tiers.length) return;

    const colorValues = bundlesWrap
      ? (bundlesWrap.getAttribute('data-color-values') || '').split('|').filter(Boolean)
      : [];

    tiers.forEach((tier) => {
      tier.addEventListener('click', () => {
        const radio = tier.querySelector('[data-pip-bundle-radio]');
        if (radio) radio.checked = true;

        tiers.forEach((t) => {
          t.classList.remove('is-selected');
          const existing = t.querySelector('[data-pip-tier-colors]');
          if (existing) existing.remove();
        });
        tier.classList.add('is-selected');

        const qty = parseInt(tier.getAttribute('data-quantity'), 10) || 1;
        if (quantityInput) quantityInput.value = qty;

        const isMulti = tier.getAttribute('data-is-multi-product') === 'true';
        if (!isMulti && qty > 1 && colorValues.length) {
          buildColorPickers(root, tier, qty, colorValues);
        }
      });
    });
  }

  function buildColorPickers(root, tier, qty, colorValues) {
    const body = tier.querySelector('.pip__bundle-body');
    if (!body) return;

    const container = document.createElement('div');
    container.className = 'pip__tier-colors';
    container.setAttribute('data-pip-tier-colors', '');

    const activeSwatch = root.querySelector('.pip__swatch.is-active');
    const currentColor = activeSwatch ? activeSwatch.getAttribute('data-value') : colorValues[0];

    for (let i = 0; i < qty; i++) {
      const select = document.createElement('select');
      select.className = 'pip__tier-color-select';
      select.setAttribute('data-pip-tier-color-select', '');

      colorValues.forEach((val) => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = 'Item ' + (i + 1) + ': ' + val;
        if (val === currentColor) opt.selected = true;
        select.appendChild(opt);
      });

      select.addEventListener('click', (e) => e.stopPropagation());
      container.appendChild(select);
    }

    body.appendChild(container);
  }

  function initAddToCart(root) {
    const form = root.querySelector('[data-pip-form]');
    const btn = root.querySelector('[data-pip-add-btn]');
    const bundlesWrap = root.querySelector('[data-pip-bundles]');

    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';

      const selectedTier = root.querySelector('[data-pip-bundle-tier].is-selected');
      const colorSelects = selectedTier ? selectedTier.querySelectorAll('[data-pip-tier-color-select]') : [];

      let fetchPromise;

      if (colorSelects.length && root._pipFindVariantWithOverrides && bundlesWrap) {
        const colorOptionIndex = parseInt(bundlesWrap.getAttribute('data-color-option-index'), 10);
        const items = [];

        colorSelects.forEach((select) => {
          const overrides = {};
          overrides[colorOptionIndex] = select.value;
          const variant = root._pipFindVariantWithOverrides(overrides);
          if (variant) items.push({ id: variant.id, quantity: 1 });
        });

        if (items.length) {
          fetchPromise = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          });
        }
      }

      if (!fetchPromise) {
        fetchPromise = fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
      }

      fetchPromise
        .then((res) => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('pip:added-to-cart'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));

          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('is-loading');
          }, 1600);
        })
        .catch(() => {
          btn.textContent = 'Something went wrong';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('is-loading');
          }, 1800);
        });
    });
  }

  function initDescriptionToggle(root) {
    const wrap = root.querySelector('[data-pip-description]');
    const inner = root.querySelector('[data-pip-description-inner]');
    const toggle = root.querySelector('[data-pip-description-toggle]');

    if (!wrap || !inner || !toggle) return;

    if (inner.scrollHeight <= 130) {
      toggle.style.display = 'none';
      return;
    }

    toggle.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Read less' : 'Read more';
    });
  }

  function initBundleTimer(root) {
    const timerEl = root.querySelector('[data-pip-bundle-timer]');
    const timerValueEl = root.querySelector('[data-pip-bundle-timer-value]');
    if (!timerEl || !timerValueEl) return;

    const DURATION_MS = 15 * 60 * 1000;
    const storageKey = 'pip_bundle_timer_' + (root.getAttribute('data-product-id') || 'x');

    let startedAt = sessionStorage.getItem(storageKey);
    if (!startedAt) {
      startedAt = Date.now().toString();
      sessionStorage.setItem(storageKey, startedAt);
    }

    function tick() {
      const elapsed = Date.now() - parseInt(startedAt, 10);
      let remaining = DURATION_MS - elapsed;

      if (remaining <= 0) {
        startedAt = Date.now().toString();
        sessionStorage.setItem(storageKey, startedAt);
        remaining = DURATION_MS;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      timerValueEl.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }

    tick();
    setInterval(tick, 1000);
  }
})();